export enum AbilityEnum {
  view = "view",
  use = "use",
  manage = "manage",
  administrate = "administrate",
  financing = "financing",
  supreme = "supreme",
}
